'use strict';

var React = require("react");

function Icons$GitHub(Props) {
  return React.createElement("svg", {
              role: "img",
              title: "GitHub",
              height: "24",
              width: "24",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  clipRule: "evenodd",
                  d: "M12.026,2c-5.509,0-9.974,4.465-9.974,9.974c0,4.406,2.857,8.145,6.821,9.465\tc0.499,0.09,0.679-0.217,0.679-0.481c0-0.237-0.008-0.865-0.011-1.696c-2.775,0.602-3.361-1.338-3.361-1.338\tc-0.452-1.152-1.107-1.459-1.107-1.459c-0.905-0.619,0.069-0.605,0.069-0.605c1.002,0.07,1.527,1.028,1.527,1.028\tc0.89,1.524,2.336,1.084,2.902,0.829c0.091-0.645,0.351-1.085,0.635-1.334c-2.214-0.251-4.542-1.107-4.542-4.93\tc0-1.087,0.389-1.979,1.024-2.675c-0.101-0.253-0.446-1.268,0.099-2.64c0,0,0.837-0.269,2.742,1.021\tc0.798-0.221,1.649-0.332,2.496-0.336c0.849,0.004,1.701,0.115,2.496,0.336c1.906-1.291,2.742-1.021,2.742-1.021\tc0.545,1.372,0.203,2.387,0.099,2.64c0.64,0.696,1.024,1.587,1.024,2.675c0,3.833-2.33,4.675-4.552,4.922\tc0.355,0.308,0.675,0.916,0.675,1.846c0,1.334-0.012,2.41-0.012,2.737c0,0.267,0.178,0.577,0.687,0.479\tC19.146,20.115,22,16.379,22,11.974C22,6.465,17.535,2,12.026,2z",
                  fillRule: "evenodd"
                }));
}

var GitHub = {
  make: Icons$GitHub
};

function Icons$Sun(Props) {
  return React.createElement("svg", {
              role: "img",
              height: "24",
              width: "24",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M6.993 12c0 2.761 2.246 5.007 5.007 5.007s5.007-2.246 5.007-5.007S14.761 6.993 12 6.993 6.993 9.239 6.993 12zM12 8.993c1.658 0 3.007 1.349 3.007 3.007S13.658 15.007 12 15.007 8.993 13.658 8.993 12 10.342 8.993 12 8.993zM10.998 19H12.998V22H10.998zM10.998 2H12.998V5H10.998zM1.998 11H4.998V13H1.998zM18.998 11H21.998V13H18.998z"
                }), React.createElement("path", {
                  d: "M4.487 17.01H7.487V19.01H4.487z",
                  transform: "rotate(-45.017 5.986 18.01)"
                }), React.createElement("path", {
                  d: "M16.508 4.99H19.509V6.99H16.508z",
                  transform: "rotate(-45.001 18.008 5.99)"
                }), React.createElement("path", {
                  d: "M4.487 4.99H7.487V6.99H4.487z",
                  transform: "rotate(-134.983 5.988 5.99)"
                }), React.createElement("path", {
                  d: "M17.008 16.51H19.008V19.511000000000003H17.008z",
                  transform: "rotate(134.999 18.008 18.01)"
                }));
}

var Sun = {
  make: Icons$Sun
};

function Icons$Moon(Props) {
  return React.createElement("svg", {
              role: "img",
              height: "24",
              width: "24",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  d: "M20.742,13.045c-0.677,0.18-1.376,0.271-2.077,0.271c-2.135,0-4.14-0.83-5.646-2.336c-2.008-2.008-2.799-4.967-2.064-7.723 c0.092-0.345-0.007-0.713-0.259-0.965C10.444,2.04,10.077,1.938,9.73,2.034C8.028,2.489,6.476,3.382,5.241,4.616 c-3.898,3.898-3.898,10.243,0,14.143c1.889,1.889,4.401,2.93,7.072,2.93c2.671,0,5.182-1.04,7.07-2.929 c1.236-1.237,2.13-2.791,2.583-4.491c0.092-0.345-0.008-0.713-0.26-0.965C21.454,13.051,21.085,12.951,20.742,13.045z M17.97,17.346c-1.511,1.511-3.52,2.343-5.656,2.343c-2.137,0-4.146-0.833-5.658-2.344c-3.118-3.119-3.118-8.195,0-11.314 c0.602-0.602,1.298-1.102,2.06-1.483c-0.222,2.885,0.814,5.772,2.89,7.848c2.068,2.069,4.927,3.12,7.848,2.891 C19.072,16.046,18.571,16.743,17.97,17.346z"
                }));
}

var Moon = {
  make: Icons$Moon
};

exports.GitHub = GitHub;
exports.Sun = Sun;
exports.Moon = Moon;
/* react Not a pure module */
